import { useSnackbar } from "notistack";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

/**
 * Returns a callback that shows an error toast when client-side form validation fails.
 * Pass it as the `onInvalid` argument of react-hook-form `handleSubmit`.
 */
export const useFormValidationToast = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  return useCallback(() => {
    enqueueSnackbar(t("Form.validationErrorToast"), { variant: "error", preventDuplicate: true });
  }, [enqueueSnackbar, t]);
};
